import { useMutation, useQueryClient } from '@tanstack/react-query'
import { z } from 'zod'
import { type ClaimRequest, QueueItemDetail } from '@rp/contracts'
import { useReadySession } from '../../session/useSession'
import { queueKeys } from '../queue/queries'

export const useClaimItem = (itemId: string) => {
  const { api } = useReadySession()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ takeover }: ClaimRequest) =>
      (await api.request(QueueItemDetail, { method: 'POST', path: `/v1/queue/${itemId}/claim`, body: { takeover } satisfies ClaimRequest }))
        .data,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: queueKeys.all }),
  })
}

export const useReleaseItem = (itemId: string) => {
  const { api } = useReadySession()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      await api.request(z.null(), { method: 'DELETE', path: `/v1/queue/${itemId}/claim` })
    },
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: queueKeys.all }),
  })
}
